module.exports = __webpack_public_path__ + "static/media/atom-chat-logo.1839b500.png";